@if (showBackgroundContainer) {
    <ms-header [titleIcon]="titleIcon" [backgroundContainerConfig]="backgroundContainerConfig" [globalLinkConfig]="globalLinkConfig" />
}

@if (isLoaderVisible) {
    <ms-ghost-loader />
}

@if ((promotionTiles.length || tiles.length) && !isLoaderVisible) {
    <ms-scroll-adapter size="medium" [scrollSpeed]="scrollSpeed" [buttonSize]="36">
        <ul class="center" [ngClass]="getListCardClass()">
            @for (promotion of promotionTiles; track promotion.id; let promoIndex = $index) {
                <li class="marquee-card card crm-promo-card" [ngClass]="crmPromotionClass" [attr.data-index]="promoIndex">
                    <ms-crm-promotion-banner [promotion]="promotion" [listIndex]="promoIndex" [trackingSource]="promotionTrackingSource" />
                </li>
            }
            @for (tile of tiles; track trackTile(tile); let index = $index) {
                <li
                    class="marquee-card card"
                    [ngClass]="setClass(index)"
                    [attr.data-index]="index"
                    [class.v2-marquee]="marqueeConfig.marqueeVariant === v2MarqueeVariant">
                    @if (isTile(tile)) {
                        @if (isTileType(tile, 'BuildABet')) {
                            <ms-betbuilder-card
                                [tile]="tile"
                                [page]="page"
                                [preventNavigation]="preventNavigation"
                                [trackingPosition]="tileIndex(index)"
                                (click)="track(tileIndex(index), tile)" />
                        } @else if (isTileType(tile, 'Regular')) {
                            @if (promotedFixtureIdsMap[getEvent(tile)]) {
                                <ms-promotion-badge />
                            }

                            @switch (tilesWithFallbackMarketType[index].marketType) {
                                @case ('CorrectScore') {
                                    <ms-correct-score-card
                                        [tile]="tile"
                                        [page]="page"
                                        [preventNavigation]="preventNavigation"
                                        [backgroundImage]="tile.source?.imageUrl"
                                        [trackingPosition]="tileIndex(index)"
                                        (click)="track(tileIndex(index), tile)"
                                        (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @case ('DynamicCorrectScore') {
                                    <ms-correct-score-card
                                        [tile]="tile"
                                        [page]="page"
                                        [preventNavigation]="preventNavigation"
                                        [backgroundImage]="tile?.source?.imageUrl"
                                        [trackingPosition]="tileIndex(index)"
                                        (click)="track(tileIndex(index), tile)"
                                        (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @case ('SixPack') {
                                    <ms-six-pack-event
                                        [tile]="tile"
                                        [event]="tile.event"
                                        [textColor]="tile.source?.textColor"
                                        [backgroundImage]="tile.source?.imageUrl"
                                        [trackingPosition]="tileIndex(index)"
                                        (click)="track(tileIndex(index), tile)"
                                        (sixPackFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @default {
                                    <ms-highlights-regular-card
                                        [tile]="tile"
                                        [page]="page"
                                        [trackingPosition]="tileIndex(index)"
                                        [images]="tileImages[index]"
                                        [preventNavigation]="preventNavigation"
                                        (click)="track(tileIndex(index), tile)"
                                        (regularToCorrectScoreFallbackTile)="triggerFallbackTile($event)" />
                                }
                            }
                        } @else if (isTileType(tile, 'Special')) {
                            <ms-highlights-special-card
                                [tile]="tile"
                                [page]="page"
                                [images]="tileImages[index]"
                                [preventNavigation]="preventNavigation"
                                [trackingPosition]="tileIndex(index)"
                                (click)="track(tileIndex(index), tile)" />
                        }
                    } @else if (isPromotion(tile)) {
                        <ms-crm-promotion-banner [promotion]="tile" [listIndex]="tileIndex(index)" [trackingSource]="promotionTrackingSource" />
                    }
                </li>
            }
        </ul>
    </ms-scroll-adapter>
}
